import { TState, IFileState } from '../UploadTableFile/types';

export interface ISaveTableInfoProps {
  defaultFormData?: ITableInfo[];
  uploadTableFile: TState & IFileState;
  gameCode: string;
  onPrevStep?: (formData: ITableInfo[]) => void;
  onSubmitSuccess?: () => void;
}

export interface ITableInfo {
  name: string;
  description: string;
  sheet_name: string;
  saveStatus?: string;
}

// 表名称正则表达式
// 以字母开头，支持字母、数字和下划线，特殊字符必须使用引号或转义符号
export const PERSONAL_TABLE_NAME_REGEX = /^[a-zA-Z][a-zA-Z0-9_]*$/;

export interface ISheetTitleWithStatusProps {
  sheetName: string;
  status: string;
}

export interface ISaveResult {
  failed: string[];
  succeed: string[];
}
